// extracted by mini-css-extract-plugin
module.exports = {"stillingSpesialmodul":"dhsg2B9EZ-stillingSpesialmodul"};